import { Tabs as MUITabs, styled, tabsClasses as MUItabsClasses } from '@mui/material';
const Tabs = styled(MUITabs)(({ theme }) => {
    return {
        marginBottom: theme.spacing(2),
        [`& .${MUItabsClasses.flexContainer}`]: {
            gap: theme.spacing(3),
        },
    };
});
export default Tabs;
